import { LoginParams } from 'src/interface/user/login.interface';
import { CreateRolesParams, QueryRolesParams, UpdateRolesParams } from 'src/interface/user/role.interface';
import { adminServiceApp, reportServiceApp } from 'src/utils/constants/serviceModule';

import { Http } from 'src/utils/http';

export async function apiLogin(params: LoginParams) {
  return Http.Post('/login/query-login', params)
}

export async function apiQueryRoles(params: QueryRolesParams) {
  return Http.Post('/roles/mgmt/query-roles', params)
}

export async function apiQueryRolesAll(params?: any) {
  return Http.Post('/roles/mgmt/query-roles-all',params)
}

export async function apiGetPlatformInfoListWhere(params?: any) {
  return Http.Post('/platform/mgmt/getPlatformInfoListWhere', params, adminServiceApp)
}

export async function apiCreateRoles(params: CreateRolesParams) {
  return Http.Post('/roles/mgmt/create-batch/create-roles', params)
}

export async function apiDelRoles(params: UpdateRolesParams) {
  return Http.Post('/roles/mgmt/delete/delete-roles', params)
}

export async function apiUpdateRoles(params: UpdateRolesParams) {
  return Http.Post('/roles/mgmt/update/update-roles', params)
}

export async function apiFreezeRoles(params: UpdateRolesParams) {
  return Http.Post('/roles/mgmt/update/freeze-roles', params)
}

export async function apiUnFreezeRoles(params: UpdateRolesParams) {
  return Http.Post('/roles/mgmt/update/unfreeze-roles', params)
}

export async function apiFindUserMenus(params?: any) {
  return Http.Post('/roles/mgmt/findUserMenus', params)
}


export async function apiChangePassword(params: any) {
  return Http.Post('/user/mgmt/change-password', params)
}

export async function getSound() {
  return Http.Get('/sound/mgmt/getSound')
}

